import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import striptags from 'striptags';
import { pluralize } from 'utils';
import AddLibraryMedia from 'components/common/AddLibraryMedia';
import AddTitleAttachment from 'components/common/AddTitleAttachment';
import renderBlockErrors from './renderBlockErrors';
import FormGroup from './FormGroup';

const Group = ({
  uid,
  errors,
  label,
  childCount,
  onPreviewTextUpdate,
  onChange,
  onSelectMedia,
  onSelectTitle,
}) => {
  const handleLabelChange = e => onChange({ label: e.target.value });

  useEffect(() => {
    const labelText = [striptags(label || ''), `(${pluralize(childCount, 'item')})`].join(' ');
    onPreviewTextUpdate(labelText);
  }, [label, childCount]);

  const renderedErrors = renderBlockErrors(errors);

  return (
    <div className="content">
      <FormGroup className="mb-3" label="Label:">
        <input
          type="text"
          className="form-input"
          onChange={handleLabelChange}
          value={label}
        />
        {renderedErrors.label}
      </FormGroup>

      <div>
        <div><strong>Bulk Update Object References</strong></div>
        <div className="text-hint mb-2">Update Title/Media references for all relevant blocks in this group.</div>
        <div className="attached-item-preview justify-content-center">
          <AddLibraryMedia onChange={onSelectMedia}>
            {handleModalTrigger => (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleModalTrigger}
              >
                Select Media
              </button>
            )}
          </AddLibraryMedia>
          <span style={{ margin: '0 15px' }}>– or –</span>
          <AddTitleAttachment onChange={onSelectTitle}>
            {handleModalTrigger => (
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleModalTrigger}
              >
                Select Title
              </button>
            )}
          </AddTitleAttachment>
        </div>
      </div>
    </div>
  );
};

Group.propTypes = {
  uid: PropTypes.string,
  errors: PropTypes.object,
  label: PropTypes.string,
  childCount: PropTypes.number,
  onPreviewTextUpdate: PropTypes.func,
  onChange: PropTypes.func,
  onSelectMedia: PropTypes.func,
  onSelectTitle: PropTypes.func,
};

export default Group;
